import axios from '@/user/axios.js'

const moduleProducts = {
  namespaced: true,
  state: {
    products: []
  },
  getters: {},
  mutations: {
    SET_PRODUCTS (state, data) {
      state.products = data
    }
  },
  actions: {
    listProducts: (context) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise((resolve, reject) => {
        axios.get(`/api/products/${sellerId}`)
          .then(resp => {
            if (resp.data.success) {
              context.commit('SET_PRODUCTS', resp.data.data)
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    updateProduct: (context, payload) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      const asin = payload.asin
      return new Promise((resolve, reject) => {
        axios.put(`/api/products/${sellerId}/${asin}`, payload)
          .then(async resp => {
            if (resp.data.success) {
              await context.dispatch('listProducts')
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    uploadProducts: (context, payload) => {
      const sellerId = context.rootState.account.activeAccount.sellerId
      return new Promise((resolve, reject) => {
        const { file } = payload
        const formData = new FormData()
        formData.append('file', file)
        axios.post(`/api/products/upload/${sellerId}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(async resp => {
            if (resp.data.success) {
              // uploadが反映された最新データを取得
              await context.dispatch('listProducts')
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    }
  }
}

export default moduleProducts
